import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ContactSummary, UnallocatedUserId } from '@jms/model';

@Component({
  selector: 'portal-contact-item-picker',
  templateUrl: './contact.item.picker.component.html',
  styleUrls: ['./contact.item.picker.component.less'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ContactItemPickerComponent implements OnInit {

  /**
   * This is a clone of contact-item-picker from ContactPickerModule
   * This component is only use on PortalContactPickerModule
   * 
   * Recommend move to separated module if logic is the same, stay DRY.
   */

  @Input() public entity: ContactSummary;
  @Input() public emptyText = 'Not Set';
  @Input() public readMode = false;
  @Input() public clearTemplate = false;
  @Input() public showFull = false;
  @Input() public showToolTip = false;
  @Input() public appendTo: null;

  @Output() public clear = new EventEmitter<any>();
  @Output() public delete = new EventEmitter<ContactSummary>();

  public unallocatedUserId = UnallocatedUserId;


  constructor() { }

  ngOnInit(): void { }

  public onClear(item: any) {
    this.clear.emit(item);
  }

  public onShowFull(show) {
    this.showFull = show;
  }

}
